import { Box, Typography } from "@mui/material";
import AppDescription from "./childcomponents/appdescription";
import VersionDetails from "./childcomponents/versiondetails";
import Support from "./childcomponents/support";
import { useEffect, useState } from "react";
import settingsService from "../../data/api/settings.service";
import { DropdownModel } from "../../data/interfaces/sharedmodels";
import { setcurrentmenu } from "../../stores/menuslice";
import { useAppDispatch } from "../../stores/hooks";


export default function About(){
    const dispatch=useAppDispatch();
    const [systemInfo,setSystemInfo]=useState<DropdownModel[]>([]);
    useEffect(()=>{
        dispatch(setcurrentmenu('about'));
        settingsService.getSystemInfo().then((response)=>{
            setSystemInfo(response.data);
        });
    },[]);
    return(
        <Box sx={{textAlign:'center',p:5}}>
            {/* <Typography sx={{mb:5}} variant="h4">Ticket Repository Analtytics & Control System</Typography> */}
            
            <VersionDetails systemInfo={systemInfo}/>
            <AppDescription/>
            <Support systemInfo={systemInfo}/>
        </Box>
    )
}